import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useContent } from "../hooks/useContent";
import { useSeo } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Section } from "../components/Primitives";
import { Check, Users, Clock, Award } from "lucide-react";

export default function Residence() {
  const { t, pick } = useI18n();
  useSeo(t("nav.residence"), "La Résidence Doux Instants : RPA de catégorie 4 à Laval, à taille humaine, avec présence de personnel 24/7.");
  const { data: settings = {} } = useContent("settings");
  const { data: team = [] } = useContent("team");

  const facts = [
    { icon: Award, label: t("common.tbc"), value: pick(settings.rpa_category), k: "rpa_category" },
    { icon: Users, label: "Capacité", value: settings.capacity ? `${settings.capacity} unités` : t("common.tbc") },
    { icon: Clock, label: "Présence", value: pick(settings.care_hours) },
    { icon: Check, label: "Depuis", value: settings.founded || t("common.tbc") },
  ];

  return (
    <>
      <PageHero eyebrow={t("nav.residence")} title={t("home.presentationTitle")} subtitle={t("home.presentationBody")}
        image="https://images.pexels.com/photos/12196310/pexels-photo-12196310.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" />

      <Section tone="surface">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="residence-facts">
          {facts.map((f, i) => (
            <div key={i} className="rounded-2xl border border-black/5 bg-[#F9F6F0] p-6">
              <f.icon className="h-6 w-6 text-[#2A9D8F]" />
              <p className="mt-3 font-display text-lg">{f.value}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section tone="sage" data-testid="team-section">
        <h2 className="font-display text-3xl sm:text-4xl">Notre équipe</h2>
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {team.map((m) => (
            <div key={m.id} className="rounded-2xl border border-black/5 bg-white p-6">
              <div className="aspect-square w-20 overflow-hidden rounded-full bg-[#EEF1E9]">
                {m.image ? <img src={m.image} alt={pick(m.name)} className="h-full w-full object-cover" />
                  : <div className="flex h-full w-full items-center justify-center text-[#9CAF88]"><Users className="h-8 w-8" /></div>}
              </div>
              <h3 className="mt-4 font-display text-lg">{pick(m.name)}</h3>
              <p className="text-sm font-medium text-[#2A9D8F]">{pick(m.role)}</p>
              <p className="mt-2 text-[15px] text-[#5C6370]">{pick(m.bio)}</p>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
